import { Record as record } from 'immutable';

import { construct, fields, resolve } from '../../helpers/LinkMapper';
import Station from '../Station';

const defaults = {
    id: null,
    orderId: null,
    customerId: null,
    brand: null,
    status: null,
    fromOrigin: new Station(),
    fromDestination: new Station(),
    toOrigin: new Station(),
    toDestination: new Station(),
    fromRouteCode: null,
    toRouteCode: null,
    oldPrice: null,
    newPrice: null,
    credit: null,
    amountDue: null,
    difference: null,
    daysRemaining: null,
    created: null,
};

export default class Changeover extends record(defaults) {
    static fromJSON(json = {}) {
        return construct(Changeover, json, {
            id: fields.number,
            orderId: fields.number,
            customerId: fields.number,
            brand: fields.string,
            status: fields.string,
            fromOrigin: resolve.as(Station),
            fromDestination: resolve.as(Station),
            toOrigin: resolve.as(Station),
            toDestination: resolve.as(Station),
            fromRouteCode: fields.string,
            toRouteCode: fields.string,
            oldPrice: fields.number,
            newPrice: fields.number,
            credit: fields.number,
            amountDue: fields.number,
            difference: fields.number,
            daysRemaining: fields.number,
            created: fields.datetime,
        });
    }
}
